<template>
	<Page>
		<Intro />
	</Page>
</template>

<script>
import Page from '@/layouts/Page'
import Intro from '@/components/Intro'

export default {
	name: 'IntroView',
	components: {
		Page,
		Intro
	}
}
</script>
